module.exports = __webpack_public_path__ + "img/coloredDiamonds@2x.a49f991.webp";